import { ALLOWED_ENV, SAMPLING_RATES, SENTRY_DSN, SENTRY_LS_KEY, SENTRY_MODULES, getWhitelabellingConfig, logDebuggingInfo } from './common'
import {
  browserProfilingIntegration,
  browserTracingIntegration,
  init,
  metrics,
  moduleMetadataIntegration,
  replayIntegration,
  setTags,
  vueIntegration
} from '@sentry/vue'

import { filterErrorEvents } from './filters'
import { routeErrorsToFederatedDSN } from './transporter'

export const initializeSentry = (Vue: any, router: any, config: any, debug?: boolean) => {
  if (debug) {
    localStorage.setItem(SENTRY_LS_KEY, 'true')
  }

  try {
    if (ALLOWED_ENV.includes(config.mode)) {
      init({
        dsn: SENTRY_DSN,
        environment: config.mode,
        integrations: [
          vueIntegration({ app: Vue, tracingOptions:{trackComponents: false} }),
          browserTracingIntegration({
            router,
            enableInp: true,
            shouldCreateSpanForRequest: url => {
              return url.includes('leadconnectorhq.com') || url.includes('msgsndr.com')
            },
          }),
          browserProfilingIntegration(),
          moduleMetadataIntegration(),
          replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
          })
        ],
        beforeSend: filterErrorEvents,
        transport: routeErrorsToFederatedDSN,
        sampleRate: SAMPLING_RATES[config.mode].sampleRate, // error samples
        tracesSampleRate: SAMPLING_RATES[config.mode].tracesSampleRate, // picked randomly, starting with bare minimum
        profilesSampleRate: SAMPLING_RATES[config.mode].profilesSampleRate,
        replaysSessionSampleRate: SAMPLING_RATES[config.mode].replaysSessionSampleRate,
        replaysOnErrorSampleRate: SAMPLING_RATES[config.mode].replaysOnErrorSampleRate,
        logErrors: true,
        attachProps: true,
        ...getWhitelabellingConfig(config.mode),
      })

      setTags({
        module: SENTRY_MODULES.SPM_TS
      })

      logDebuggingInfo(`Error Tracking enabled in ${config.mode} mode`)
    } else {
      logDebuggingInfo(`Error Tracking disabled in ${config.mode} mode`)
    }
  } catch (e) {
    logDebuggingInfo('Error Tracking initialized failed')
  }
}
